"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var localization_1 = require("./classes/localization");

exports.Localization = localization_1.default;

var localization_2 = require("./constants/localization");

exports.localizationConstants = localization_2.default;

var localization_3 = require("./utils/localization");

exports.localizationUtils = localization_3.default;